import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, InfiniteScroll } from 'ionic-angular';
import { PlanningCreatePage } from '../planning-create/planning-create';
import { PlanningDetailsPage } from '../planning-details/planning-details';
import { PlanningService } from '../../providers/planning.service';
import { IPlanningListResponse } from '../../../typings/api';
import { Observable } from 'rxjs/Observable';
import { UserService } from '../../providers/user.service';
import { IPlanning } from '../../../typings/timetracker/timetracker';

/**
 * Generated class for the PlanningPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-planning-overview',
  templateUrl: 'planning-overview.html',
})
export class PlanningOverviewPage {

  public planning$: Observable<IPlanningListResponse>;
  private infiniteScroll: InfiniteScroll;
  private LIMIT = 25;
  private NUMBER_OF_ITEMS = 25;

  showDetails( planning: IPlanning ) {
    this.navCtrl.push( PlanningDetailsPage, planning );
  }

  getUserName( userId: number ) {
    return this.$userAPI.selectUserByIdFetch( userId );
  }

  createNew() {
    this.navCtrl.push( PlanningCreatePage );
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad PlanningPage');
  }

  doInfinite( infiniteScrollEvent: InfiniteScroll ) {
    this.infiniteScroll = infiniteScrollEvent;
    this.LIMIT += this.NUMBER_OF_ITEMS;
    this.$planningAPI.dispatchPlanningFetchAll( this.LIMIT, 0 );
  }

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private $userAPI: UserService,
    private $planningAPI: PlanningService ) {
      this.planning$ = this.$planningAPI.selectPlanningFetchAll().do( ( plannig ) => {
        if ( this.infiniteScroll && this.infiniteScroll.state === 'loading' ) {
          this.infiniteScroll.complete();
        }
      } );
      this.$planningAPI.dispatchPlanningFetchAll( this.LIMIT, 0 );
  }
}



// WEBPACK FOOTER //
// ./src/pages/planning-overview/planning-overview.ts